import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import startWorker from './slowerRenderWorker';
import { getBrowser } from '@src/slide/infrastructure/module/independent/agent/common';
import UserOperateJank from './user-operate-jank';

export default class SlowRenderCollector {
    public static instance: SlowRenderCollector;
    public static getInstance(): SlowRenderCollector {
        if (!SlowRenderCollector.instance) {
            SlowRenderCollector.instance = new SlowRenderCollector();
        }
        return SlowRenderCollector.instance;
    }

    private worker: Worker | null = null;
    private hasStart = false; // 只启动一次

    private hasReportSlowRenderOld = false;
    private hasReportSlowRenderNew = false;
    private userOperateJank: UserOperateJank;

    public constructor() {
        this.userOperateJank = new UserOperateJank();
    }

    public startSlowRenderMonitor = (): void => {
        if (!__IS_DEV__ && !__IS_DEV__ && !this.hasStart) { // 只有非调试模式才会走
            if (window.Worker) {
                this.hasStart = true;
                window.log?.info('startSlowRenderMonitor');
                if (!document.hidden) {
                    this.startAnimationFrame();
                }
                document.addEventListener('visibilitychange', this.handleVisibilityChange);
            }
        }
    };

    public handleVisibilityChange = (): void => {
        if (document.hidden) {
            this.cancelAnimationFrame();
        } else {
            this.startAnimationFrame();
        }
    };

    public startAnimationFrame(): void {
        if (!this.isAllReported() && !this.worker) {
            const blob = new Blob([`(${startWorker.toString()})()`]);
            const url = window.URL.createObjectURL(blob);

            const myWorker = new Worker(url);
            this.worker = myWorker;
            myWorker.onerror = (e) => {
            };
            myWorker.onmessage = (e) => {
                const { data } = e;
                // console.log('Message received from worker', data);
                switch (data.cmd) {
                    case 'reportOld':
                        this.reportOld(data);
                        break;
                    case 'reportNew':
                        this.reportNew(data);
                        break;
                    case 'send':
                        myWorker.postMessage({
                            cmd: 'result',
                        });
                        break;
                }
            };
            // 开启监听
            myWorker.postMessage({
                cmd: 'start',
            });
        }
    }

    public cancelAnimationFrame(): void {
        if (this.worker) {
            this.worker.terminate();
            this.worker = null;
        }
    }

    private isAllReported(): boolean {
        return this.hasReportSlowRenderOld && this.hasReportSlowRenderNew;
    }

    private stopIt(): void {
        if (this.hasReportSlowRenderOld && this.hasReportSlowRenderNew) {
            this.cancelAnimationFrame();
            document.removeEventListener('visibilitychange', this.handleVisibilityChange);
        }
    }

    private reportOld(data): void {
        this.hasReportSlowRenderOld = true;
        this.stopIt();
        tdw({
            opername: 'ppt_performance',
            module: 'detail',
            action: 'slow_render',
            ver5: 0,
            ver6: JSON.stringify({
                isSlowerRender: data.args.isSlowerRender,
                lastFrameTime: data.args.lastFrameTime,
                browser: getBrowser(),
            }),
        });
    }

    private reportNew(data): void {
        this.hasReportSlowRenderNew = true;
        this.userOperateJank.destory();
        this.stopIt();
        const { lastRenderTime, nowRenderTime, lastFrameTime } = data.args;
        const relateOperateInfo = this.userOperateJank.getRelateOperateInfo(lastRenderTime, nowRenderTime);
        tdw({
            opername: 'ppt_performance',
            module: 'detail',
            action: 'slow_render_new',
            ver5: 0,
            ver6: JSON.stringify({
                lastFrameTime,
                browser: getBrowser(),
                ...relateOperateInfo,
            }),
        });
    }
}
